// extracted by mini-css-extract-plugin
export default {"advertSearchLink":"Kyx4fW9-","advertSearchIcon":"_8AzTp3Pz"};